import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { FormContext } from '../Form/Form.js';
import { isValidComposedState } from '../Util/from-state.js';

const ComposedFormContext = /*#__PURE__*/ React.createContext({});
const ComposedForm = (props)=>{
    const [formState, setFormState] = React.useState(props.initialFormState);
    const state = React.useMemo(()=>({
            formName: props.name,
            formState: formState || {},
            formValid: !!formState && isValidComposedState(formState)
        })
    , [
        props.name,
        formState
    ]);
    // This effect calls onChange whenever `state` changes
    React.useEffect(()=>props.onChange && props.onChange(state)
    , [
        state
    ]);
    // This effect resets state when `initialFormState` changes
    // NOTE: this uses useLayoutEffect to work around a race condition with DateOfBirthSelect's initial onChange
    React.useLayoutEffect(()=>setFormState(props.initialFormState)
    , [
        props.initialFormState
    ]);
    // These callbacks are used by form Parts to get and update their part of `formState`
    const composedContext = {
        formName: props.name,
        onChange: React.useCallback((name, controlState)=>{
            setFormState((current)=>swcHelpers.objectSpread({}, current, {
                    [name]: swcHelpers.objectSpread({}, current && current[name], {
                        [controlState.name]: controlState
                    })
                })
            );
        }, []),
        getInitialState: React.useCallback((name)=>formState && formState[name]
        , [
            formState
        ])
    };
    // The native form's onSubmit is intercepted and the current `state` added
    const handleFormSubmit = React.useCallback((ev)=>{
        ev && ev.preventDefault() // this behavior is to remain consistent with Form
        ;
        props.onSubmit && props.onSubmit(state);
    }, [
        props.name,
        props.onSubmit,
        state
    ]);
    return /*#__PURE__*/ React.createElement(ComposedFormContext.Provider, {
        value: composedContext
    }, /*#__PURE__*/ React.createElement("form", {
        noValidate: true,
        id: props.name,
        className: props.className,
        "data-t": props['data-t'] || props.name,
        onSubmit: handleFormSubmit,
        children: props.children
    }));
};
const Part = ({ name , children ,  })=>{
    const { formName , onChange , getInitialState  } = React.useContext(ComposedFormContext);
    !onChange && console.error('ComposedForm.Part cannot be used outside of a ComposedForm');
    // These callbacks for the regular FormContext act as a proxy to add this
    // Part's `name` to get and update the correct part of ComposedForm's state
    const formContext = {
        name: formName,
        onChange: React.useCallback((state)=>onChange && onChange(name, state)
        , [
            name,
            onChange
        ]),
        getInitialState: React.useCallback((fieldName)=>(getInitialState && getInitialState(name) || {})[fieldName]
        , [
            getInitialState
        ])
    };
    return /*#__PURE__*/ React.createElement(FormContext.Provider, {
        value: formContext,
        children: children
    });
};
ComposedForm.Part = Part;

export { ComposedFormContext, ComposedForm as default };
//# sourceMappingURL=ComposedForm.js.map
